import { useState, useCallback, useEffect } from "react";

interface UseMarkdownHistoryProps {
    isEditing: boolean;
    editedDescription: string;
    setEditedDescription: (value: string) => void;
}

export const useMarkdownHistory = ({
    isEditing,
    editedDescription,
    setEditedDescription
}: UseMarkdownHistoryProps) => {
    const [history, setHistory] = useState<string[]>([]);
    const [currentIndex, setCurrentIndex] = useState(-1);

    const undo = useCallback(() => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            setEditedDescription(history[currentIndex - 1]);
        }
    }, [currentIndex, history, setEditedDescription]);

    const redo = useCallback(() => {
        if (currentIndex < history.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setEditedDescription(history[currentIndex + 1]);
        }
    }, [currentIndex, history, setEditedDescription]);

    useEffect(() => {
        if (isEditing && history.length === 0) {
            setHistory([editedDescription]);
            setCurrentIndex(0);
        }
    }, [isEditing, editedDescription, history]);

    useEffect(() => {
        if (!isEditing) {
            setHistory(prev => prev.slice(-1));
            setCurrentIndex(0);
        }
    }, [isEditing]);

    const handleChange = (val?: string) => {
        const newValue = val || '';
        setEditedDescription(newValue);

        const newHistory = history.slice(0, currentIndex + 1);
        newHistory.push(newValue);
        setHistory(newHistory);
        setCurrentIndex(newHistory.length - 1);
    };

    return { undo, redo, handleChange };
}; 